export const fields = ["a software engineer", "a writer", "a knowledge seeker", "a fitness freak", "a manga lover"];